
<template>

  <footer>

      <section class="newsletter-subscription" v-if="$route.path !== '/newsletter'">

          <div class="image image1 d-none d-sm-block"></div>
          <div class="image image2"></div>

          <div class="container-fluid">

              <div class="row">

                  <div class="col text-center">

                      <h2 class="text-uppercase">Pridruži se našim e-novicam</h2>

                      <div class="divider-image divider-image-3"></div>

                      <p>Why? Because you don’t want to miss out on all this<br> awesome content, that's why.</p>

                      <a href="/newsletter" class="load-more btn btn-danger"><i class="fal fa-envelope"></i> &nbsp; Naroči se &nbsp;</a>

                  </div>
              </div>

          </div>

      </section>

      <section class="copy">

          <div class="container">

              <div class="row">

                  <div class="col-12 col-lg-4 order-md-1 mb-3 mt-3 mt-lg-0">
                      <ul class="social">
                          <li>
                              <a href="https://www.facebook.com/Why.si.blog/"><i class="fab fa-facebook"></i></a>
                          </li>
                          <li>
                              <a href="https://www.instagram.com/thats.why.si/"><i class="fab fa-instagram"></i></a>
                          </li>
                          <li>
                              <a href="https://www.youtube.com/channel/UCnbpRZpBWa85d-wUrXaOlRg"><i class="fab fa-youtube"></i></a>
                          </li>
                          <li>
                              <a href="/newsletter"><i class="fal fa-envelope"></i></a>
                          </li>
                          <li>
                              <a href="/sitemap"><i class="fal fa-globe"></i></a>
                          </li>
                      </ul>
                  </div>

                  <div class="col-12 col-lg-4 order-md-2 text-center">
                        <a href="/"><img src="/images/logo.grey.png" class="img-fluid" alt="WHY Logotype"></a>
                  </div>

                  <div class="col-12 col-lg-4 order-md-3 mt-3 mt-lg-0 text-right copy-text">
                      <p>Why.si © {{ year }} - Taste, that's why.</p>
                  </div>
              </div>

          </div>
      </section>

  </footer>

</template>

<script>
  export default {
    data () {
      return {
          year: (new Date()).getFullYear()
      }
    }
  }
</script>

<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/layout/Footer.vue